"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapNodeToAddress = void 0;
const mapNodeToAddress = (node, values) => {
  const result = {
    ...values
  };
  Object.keys(node).forEach(nodeKey => {
    const addressNodeKey = nodeKey;
    const addressValue = node[addressNodeKey];
    if (addressNodeKey === 'type' || addressNodeKey === 'buildingDetails') {
      return;
    }
    const mappedKey = addressNodeKey === 'street' ? 'streetAddress' : addressNodeKey === 'zipCode' ? 'zipcode' : addressNodeKey;
    if (addressValue && addressValue !== '') {
      result[mappedKey] = addressValue;
    }
  });
  return result;
};
exports.mapNodeToAddress = mapNodeToAddress;
//# sourceMappingURL=nodeToAddressMapper.js.map